import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../components/TranslationContext';
import { Helmet } from 'react-helmet';
import '../styles/hero-section.css';
import '../styles/gallery-section.css';
import '../styles/trust-section.css';
import '../styles/root.css';
import heroImage from '../assets/79.jpg';
import galleryImage1 from '../assets/1.jpg';
import galleryImage2 from '../assets/2.jpg';
import galleryImage3 from '../assets/3.jpg';
import galleryImage4 from '../assets/4.jpg';
import galleryImage5 from '../assets/5.jpg';
import galleryImage6 from '../assets/17.jpg';
import galleryImage7 from '../assets/22.jpg';
import galleryImage8 from '../assets/8.jpg';
import galleryImage9 from '../assets/29.jpg';
import marqueeImage1 from '../assets/partenaires/Logo-armee.png';
import marqueeImage2 from '../assets/partenaires/policenationale.png';
import marqueeImage3 from '../assets/partenaires/gendarmerie.png';
import marqueeImage4 from '../assets/partenaires/ciel.png';
import marqueeImage5 from '../assets/partenaires/jordache.png';
import marqueeImage6 from '../assets/partenaires/molinel.png';
import marqueeImage7 from '../assets/partenaires/paulboye.jpg';
import marqueeImage8 from '../assets/partenaires/robur.png';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const fadeInElements = useRef([]);
  const { translate } = useTranslation();
  const home = translate('home');

  useEffect(() => {
    const handleScroll = () => {
      fadeInElements.current.forEach(element => {
        if (isElementInViewport(element)) {
          element.classList.add('active');
        }
      });
    };

    const isElementInViewport = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    fadeInElements.current = Array.from(document.querySelectorAll('.fade-in'));
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const galleryImages = [
    galleryImage1, galleryImage2, galleryImage3,
    galleryImage4, galleryImage5, galleryImage6,
    galleryImage7, galleryImage8, galleryImage9
  ];

  return (
    <>
      <Helmet>
        <title>Marine & Moi - Accueil</title>
        <meta name="description" content="Votre fournisseur de textiles premium. Confiez-nous la réalisation de vos collections, du prêt à porter au vêtement technique, en passant par vos accessoires les plus luxueux." />
        <meta name="keywords" content="textiles, premium, collections, prêt à porter, vêtement technique, accessoires, luxe" />
      </Helmet>
      <section className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h1 className="hero-title fade-in">{home.heroTitle}</h1>
          <p className="hero-subtitle fade-in">{home.heroSubtitle}</p>
          <Link to="/savoirfaire"><button className="hero-cta fade-in">{home.heroCTA}</button></Link>
        </div>
      </section>
      <section className="gallery-section">
        <div className="container">
          <h1 className="gallery-title">{home.galleryTitle}</h1>
          <h2 className="gallery-subtitle">{home.gallerySubtitle}</h2>
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Savoir-faire textile ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <Link to="/savoirfaire" className="gallery-cta">{home.galleryCTA}</Link>
        </div>
      </section>
      <section className="trust-section">
        <div className="container">
          <h1 className="trust-title">{home.trustTitle}</h1>
          <h2 className="trust-subtitle">{home.trustSubtitle}</h2>
          <p className="trust-text">
            {home.trustText}
          </p>
          <div className="marquee-wrapper">
            <div className="marquee">
              <div className="marquee-group">
                <div className="marquee-item">
                  <img src={marqueeImage1} alt="Logo Armée de Terre" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage2} alt="Logo Police Nationale" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage3} alt="Logo Gendarmerie" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage4} alt="Logo Ciel" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage5} alt="Logo Jordache" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage6} alt="Logo Molinel" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage7} alt="Logo Paul Boyé" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage8} alt="Logo Robur" />
                </div>
              </div>
              <div className="marquee-group" aria-hidden="true">
                <div className="marquee-item">
                  <img src={marqueeImage1} alt="Logo Armée de Terre" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage2} alt="Logo Police Nationale" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage3} alt="Logo Gendarmerie" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage4} alt="Logo Ciel" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage5} alt="Logo Jordache" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage6} alt="Logo Molinel" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage7} alt="Logo Paul Boyé" />
                </div>
                <div className="marquee-item">
                  <img src={marqueeImage8} alt="Logo Robur" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
